//enums
import {MENU_OPTION} from '@/utils/enums';
//types
import {IOrganizationTablesTicket} from '@/utils/types';

export const tableTicketMenuContent = [
	MENU_OPTION.GO_TO_PROFILE,
	MENU_OPTION.EMAIL_TICKET,
	MENU_OPTION.MARK_AS_PAID,
	MENU_OPTION.REMOVE,
];

export const handleDeleteTableItem = (tickets: IOrganizationTablesTicket[], ticketId: number) =>
	tickets.filter((ticket) => ticket.id !== ticketId);
